import axios from 'axios'
import {API_NOTICIAS} from "../consts/api";

export default async function(qtd = null) {
  try{
    const resp = await axios.post(API_NOTICIAS);

    let items = resp.data;

    if(qtd !== null) { return items.splice(0, qtd) }

    return items

  }catch (e) {
    throw e;
  }
}
